import { IHelperFunctionsModelNormalizer } from "./IHelperFunctionsCallContext";

export class HelperFunctionsModelNormalizer implements IHelperFunctionsModelNormalizer {
    public normalizeSections(): void {
        // NOTE Кажется от этого вызова отказались
        // eslint-disable-next-line no-console
        console.warn("Если вы встретили это сообщение обратитесь к разработчикам");
    }
}
